import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Event, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { LoginModalComponent } from '../../components/login-modal/login-modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CoursesService } from '../../courses.service';
import { ProgressService } from '../../progress.service';
import { ConnectionService } from '../../course/services/connection.service';
import { SignupModalComponent } from '../../components/signup-modal/signup-modal.component';
import { take } from 'rxjs/operators';
import { ClaimsService } from '../../services/claims.service';
import {AuthContextService} from '../../services/auth-context.service';


@Component({
  selector: 'app-token-claim',
  templateUrl: './token-claim.component.html',
  styleUrls: ['./token-claim.component.scss']
})
export class TokenClaimComponent implements OnInit {

  code: string= '';
  user: any;
  course: any;
  verification: any;
  showSignup = false;
  showLoginForm = false;
  loading = true;
  foundCode = false;
  error: any;

  constructor(
    private authContextService: AuthContextService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: BsModalService,
    private coursesService: CoursesService,
    private claimsService: ClaimsService
  ) {
  }

  ngOnInit(): void {
    if (this.route.snapshot.params.code) {
      this.code = this.route.snapshot.params.code;
    }

    this.course = this.coursesService.loadCourse('PRIVATE').subscribe(value => {
      this.course = value;
    });

    if (this.code) {
      this.foundCode = true;
      this.findCode(this.code);
    } else {
      this.foundCode = false;
      this.loading = false;
    }

    this.authContextService.onLogin().subscribe(value => {
      this.user = value;
      this.showLoginForm = false;
      this.showSignup = false;

      this.claimsService.claim(this.code).then(value1 => {
        this.verification = value1;
      });
    });
  }

  signup($event) {
    $event.preventDefault();
    $event.stopPropagation();
    this.showSignup = true;
  }

  findCode(code: string) {
    this.error = null;
    this.claimsService.verify(code).then((result) => {
      this.foundCode = true;
      this.verification = result;
      if (!this.verification.user) {

        this.authService.renew().then(value => {
          this.user = value;
          if (this.user) {
            this.claimsService.claim(code).then(value1 => {
              this.verification = value1;
              this.loading = false;
            });
          }
          this.loading = false;
        }, (error) => {
          this.user = null;
          this.loading = false;
          this.error = error.error;
        });
      }
    }, (error) => {
      this.loading = false;
      this.foundCode = false;
      this.error = error.error;
    });
  }

  /*signup($event) {
    $event.stopPropagation();
    $event.preventDefault();

    const initialState = {onComplete: this.onLoginComplete, course: this.course};

    this.signupModal = this.modalService.show(SignupModalComponent, {initialState, class: 'modal-lg rounded-modal'});
    this.signupModal.content.closeBtnName = 'Close';

    this.modalService.onHide.pipe(take(1)).subscribe(value => {
      console.log('LoginModalComponent:' + value);
      if (this.signupModal.content.user) {
        this.onLoginComplete();
      }
    });

  }*/

  toggleLoginForm($event): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.showLoginForm = !this.showLoginForm;
  }

  onLoginFormComplete(): void {
    this.showLoginForm = !this.showLoginForm;
    this.onLoginComplete();
  }

  onLoginFormCancel(): void {
    this.showLoginForm = !this.showLoginForm;
  }

  onShowSignupForm($event) {
    this.showSignup = true;
    this.showLoginForm = false;
  }

  onSignupCompleted($event) {
    this.showSignup = false;
    this.onLoginComplete();
  }

  onSignupCancel($event) {
    this.showSignup = false;
  }

  onRegisterCompleted($event) {
    this.showSignup = false;
    this.onLoginComplete();
  }

  onLoginComplete() {
    this.showLoginForm = false;
    this.showSignup = false;
    this.authService.renew().then(value => {
      this.user = value;
    });
  }
}
